import React from 'react'
import Title from '../Title'
import Project from './Project'

import { Wrap, Center } from "./style"

const Projects = ({projects}) => {
  
  return (
    <Wrap>
      <Title title={"All Projects"} />
      <Center>
        {projects.map((project) => {
          return <Project key={project.id} {...project} />
        })}
      </Center>
    </Wrap>
  )
}

export default Projects;